import { z } from 'zod'

// --- Auth Status ---
export type AuthStatus = 'checking' | 'authenticated' | 'not-authenticated'

// --- Login ---
export const loginFormSchema = z.object({
  emailRut: z.string().min(1, 'Email o RUT es requerido'),
  password: z.string().min(1, 'Contraseña es requerida'),
})

export type LoginFormData = z.infer<typeof loginFormSchema>

// --- Login Response (from POST /login/) ---
export interface LoginResponse {
  user_id: number
  user_rut: string
  user_email: string
  user_role: UserRole
  id_company: number
  token: string
  id_branch_office: number
}

// --- User (from GET /users/{id}) ---
export interface User {
  id: string
  name: string
  last_name: string
  rut: string
  email: string
  role: UserRole
  id_company: number
  id_branch_office: number
  password?: string
}

// --- Roles ---
export type UserRole = 'Admin' | 'User'

// --- Auth User (stored in Zustand, derived from LoginResponse) ---
export interface AuthUser {
  userId: number
  rut: string
  email: string
  role: UserRole
  companyId: number
  branchOfficeId: number
}
